export default "__VITE_ASSET__CK89N$MK__"